export const LOAD_POSITION_LIST = 'position/LOAD_POSITION_LIST';
export const LOAD_POSITION_LIST_SUCCESS = 'position/LOAD_POSITION_LIST_SUCCESS';
export const LOAD_POSITION_LIST_ERROR = 'position/LOAD_POSITION_LIST_ERROR';
export const RESET_POSITION_LIST = 'position/RESET_POSITION_LIST';

export const ADD_POSITION = 'position/ADD_POSITION';
export const ADD_POSITION_SUCCESS = 'position/ADD_POSITION_SUCCESS';
export const ADD_POSITION_ERROR = 'position/ADD_POSITION_ERROR';

export const UPDATE_POSITION = 'position/UPDATE_POSITION';
export const UPDATE_POSITION_SUCCESS = 'position/UPDATE_POSITION_SUCCESS';
export const UPDATE_POSITION_ERROR = 'position/UPDATE_POSITION_ERROR';

export const DELETE_POSITION = 'position/DELETE_POSITION';
export const DELETE_POSITION_SUCCESS = 'position/DELETE_POSITION_SUCCESS';
export const DELETE_POSITION_ERROR = 'position/DELETE_POSITION_ERROR';
